import React from 'react';
import { motion } from 'framer-motion';
import { SacredGeometry } from './SacredGeometry';
export function Manifesto() {
  return <section className="relative w-full bg-white py-32 px-6 overflow-hidden" data-id="element-190">
      <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] pointer-events-none" data-id="element-191">
        <SacredGeometry data-id="element-192" />
      </div>

      <div className="relative max-w-3xl mx-auto z-10" data-id="element-193">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="font-serif italic text-teal-dark text-3xl md:text-4xl lg:text-5xl text-center leading-tight mb-16" data-id="element-194">
          "Algo no termina de moverse.
          <br data-id="element-195" />Y no es falta de voluntad."
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-6 text-lg text-gray-700 font-light leading-relaxed" data-id="element-196">
          <p className="font-serif italic text-xl text-gray-800" data-id="element-197">
            Hay algo que muy pocas personas se permiten decir en voz alta:
          </p>
          <p className="font-serif italic text-2xl text-teal-dark border-l-2 border-gold pl-6 my-8" data-id="element-198">
            "Hice todo lo que se supone que tenía que hacer.
            <br data-id="element-199" />Y algo sigue sin moverse."
          </p>
          <p data-id="element-200">
            No es falta de esfuerzo. No es falta de conciencia. No es que no
            hayas trabajado en ti mismo/a.
          </p>
          <p data-id="element-201">
            Es que existe una capa — una capa energética concreta, real,
            accesible con las herramientas correctas — que la mayoría de los
            enfoques simplemente no alcanza.
          </p>
          <p data-id="element-202">
            Lo que ocurre en esa capa no siempre viene de afuera. A veces son
            bloqueos que se construyeron sin saberlo, como respuesta a
            experiencias que el sistema no supo procesar de otra manera. A veces
            son patrones que el alma misma trajo para atravesar algo — y que
            todavía no fueron reconocidos como tales.
          </p>
          <p className="font-serif italic text-xl text-teal-dark pt-4" data-id="element-203">
            Lo importante no es el origen. Lo importante es esto:
          </p>
          <p className="font-serif italic text-xl text-teal-dark" data-id="element-204">
            ¿Está siendo atendido?
            <br data-id="element-205" />
            ¿O sigue ahí, haciendo lo que siempre hizo?
          </p>
        </motion.div>
      </div>
    </section>;
}